import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Button, Typography, Toolbar, Grid, TextField, Fade } from '@material-ui/core';
import { Home as HomeIcon, NavigateNext as NavigateIcon } from '@material-ui/icons';
import history from '../../history/browserHistory';

const styles = theme => ({
  content: {
    padding: theme.spacing.unit * 5,
    paddingTop: theme.spacing.unit * 13,
    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing.unit * 12,
    },
    height: '100vh',
    overflowY: 'scroll',
  },
  search: {
    padding: theme.spacing.unit * 3,
    flexBasis: '25%',
  },
  searchOr: {
    paddingTop: 50,
  },
  navigation: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 40,
    paddingLeft: theme.spacing.unit * 3,
  },
  capitalize: {
    textTransform: 'uppercase',
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    marginTop: 20,
  },
  container: {
    padding: 50,
  },
  howTo: {
    marginTop: theme.spacing.unit * 10,
    marginBottom: theme.spacing.unit,
    display: 'flex',
    alignItems: 'center',
  },
  showHide: {
    paddingLeft: theme.spacing.unit,
    paddingTop: 2,
    textDecoration: 'underline',
    fontSize: 12,
    cursor: 'pointer',
    userSelect: 'none',
  },
  navigate: {
    color: theme.palette.text.secondary,
    width: theme.spacing.unit * 6,
  },
  link: {
    color: theme.palette.text.secondary,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
});

class SearchBillOfLading extends React.Component {
  state = {
    billOfLading: '',
    containerNumber: '',
    vesselStay: '',
    errors: {},
    howToVisible: false,
  };

  static hasErrors = errors => !!Object.keys(errors).length;

  getOnChangeField = fieldName => event => {
    if (SearchBillOfLading.hasErrors(this.state.errors)) {
      this.setState({ errors: {} });
    }
    this.setState({ [fieldName]: event.target.value });
  };

  getOnSubmit = (billOfLadingErrorField, abbreviation, uniqueField) => () => {
    const errors = {};

    if (!this.state.billOfLading) {
      errors[billOfLadingErrorField] = true;
    }

    if (!this.state[uniqueField]) {
      errors[uniqueField] = true;
    }

    if (SearchBillOfLading.hasErrors(errors)) {
      this.setState({
        errors,
      });
    } else {
      history.push(`/${this.state.billOfLading}/${abbreviation}/${this.state[uniqueField]}`);
    }
  };

  onShowHide = () => {
    this.setState({ howToVisible: !this.state.howToVisible });
  };

  render() {
    const { classes } = this.props;
    const { howToVisible } = this.state;

    return (
      <main className={classes.content}>
        <div className={classes.navigation}>
          <Link to="/">
            <HomeIcon className={classes.link} />
          </Link>
          <NavigateIcon className={classes.navigate} />
          <Link to="/">
            <Typography
              variant="subtitle2"
              className={classNames(classes.capitalize, classes.link)}
            >
              Import Consignment
            </Typography>
          </Link>
        </div>
        <Paper className={classes.container}>
          <Toolbar className={classes.title}>
            <Typography variant="h5">Search a consignment</Typography>
          </Toolbar>
          <Grid container justify="center">
            <Grid item xs={5} className={classes.search}>
              <TextField
                id="standard-read-only-input"
                label="Bill of Lading number"
                margin="normal"
                fullWidth
                value={this.state.billOfLading}
                error={this.state.errors.billOfLadingCN}
                onChange={this.getOnChangeField('billOfLading')}
              />
              <TextField
                id="standard-read-only-input"
                label="Container number"
                margin="normal"
                fullWidth
                value={this.state.containerNumber}
                error={this.state.errors.containerNumber}
                onChange={this.getOnChangeField('containerNumber')}
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  size="large"
                  variant="contained"
                  color="primary"
                  onClick={this.getOnSubmit('billOfLadingCN', 'cn', 'containerNumber')}
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
            </Grid>
            <Grid item xs={1} className={classes.searchOr}>
              <Typography variant="h5" align="center">
                OR
              </Typography>
            </Grid>
            <Grid item xs={5} className={classes.search}>
              <TextField
                id="standard-read-only-input"
                label="Bill of Lading number"
                margin="normal"
                fullWidth
                value={this.state.billOfLading}
                error={this.state.errors.billOfLadingVS}
                onChange={this.getOnChangeField('billOfLading')}
              />
              <TextField
                id="standard-read-only-input"
                label="Vesselstay"
                margin="normal"
                fullWidth
                value={this.state.vesselStay}
                error={this.state.errors.vesselStay}
                onChange={this.getOnChangeField('vesselStay')}
              />
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  size="large"
                  variant="contained"
                  color="primary"
                  onClick={this.getOnSubmit('billOfLadingVS', 'sn', 'vesselStay')}
                  className={classes.button}
                >
                  Search
                </Button>
              </div>
            </Grid>
          </Grid>
          <div className={classes.howTo}>
            <Typography variant="subtitle2">How to search for a consignment</Typography>
            <Typography className={classes.showHide} onClick={this.onShowHide}>
              {howToVisible ? 'Hide' : 'Show'}
            </Typography>
          </div>
          <Fade in={howToVisible}>
            <Typography>
              The Import Consignment Form returns the consignment data as it is received in the
              CUSCAR messages from the Shipping agent. These CUSCAR messages are sent in to customs
              to declare the cargo discharged at a terminal. You can re-use this data to make
              Customs declarations.
              <br />
              <br />
              In order to retrieve the data from this NxtPort service, you need to provide a unique
              key (combination of BL number/Container number or BL number/Vessel stay), which
              identifies the cargo objects.
            </Typography>
          </Fade>
        </Paper>
      </main>
    );
  }
}

SearchBillOfLading.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SearchBillOfLading);
